import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
// Delay loaded components
export var FileProviderView = createLazyComponent(lazyModule, function (m) { return m.FileProviderView; });
export var FileProvidersToAddListView = createLazyComponent(lazyModule, function (m) { return m.FileProvidersToAddListView; });
//# sourceMappingURL=index.js.map